<script>
import store from "@/store";

export default {
  name: 'Redirect',
  beforeRouteEnter(to, from, next) {
    const {params} = to;
    const { pages: [{ route = 'home' } = {}] = [] } = store.getters['project/project'];

    next({path: `/${params.order}/${route}`});
  },
}
</script>
